<template>
    <div class="energy-check-container">
        <div class="search_wraps-check">
            <el-form :inline="true" :model="searchForm" class="leader-style-form">
                <el-form-item label="时间" style="float: left">
                    <el-date-picker
                        v-model="searchForm.time"
                        type="month"
                        placeholder="选择日期"
                        value-format="yyyy-MM"
                        format="yyyy-MM"
                        :picker-options="pickerOptions"
                        :clearable="false"
                        :editable="false"
                    ></el-date-picker>
                    <el-button type="primary" style="margin-left: 20px" @click="search">查询</el-button>
                </el-form-item>
            </el-form>
        </div>

        <div class="check-wrap">
            <!-- <h2 class="check-title" style="margin-left: 38px">
                万元产值综合能耗
            </h2>-->
            <div class="check-echarts-wrap">
                <v-chart
                    :auto-resize="true"
                    :options="energyCheckBar"
                    ref="energyCheckBar"
                    theme="ovilia-green"
                    @click="consumpClick"
                />
            </div>
        </div>
    </div>
</template>
<script>
import "echarts/lib/chart/bar";
import "echarts/lib/chart/line";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
import "echarts/lib/component/graphic";
import * as api from "@/http/api.js";
import utils from "@/utils/utils";
export default {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            searchForm: {
                time: ""
            },
            selectMonth: "",
            x_list: [],
            y_list: [],
            y_list_right: []
        };
    },
    created() {
        this.getSysDate();
    },
    methods: {
        search() {
            this.getConsumption(this.searchForm.time);
        },
        getSysDate() {
            api.getSysDate1().then(res => {
                if (res && res.error_code === "0") {
                    this.searchForm.time = res.bus_json.sysdate3;
                    this.selectMonth = this.searchForm.time;
                    this.getConsumption();
                }
            });
        },
        //获取柱状图
        getConsumption() {
            api.getConsumption({
                ny: this.searchForm.time
            }).then(res => {
                if (res && res.error_code === "0") {
                    this.x_list = res.bus_json.xzList;
                    this.y_list = res.bus_json.nhList;
                    this.y_list_right = res.bus_json.czList;
                }
            });
        }
    },
    computed: {
        energyCheckBar() {
            const option = {
                title: {
                    text: "18个月万元产值综合电耗趋势",
                    textStyle: {
                        color: utils.getFontColor()
                    },
                    left: "center"
                },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        // 坐标轴指示器，坐标轴触发有效
                        type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
                    },
                    formatter: function (params) {
                        var tar_left = params[0];
                        var tar_right = params[1];
                        console.log(params);
                        // return "综合能耗:"+tar.data.value+"元";
                        return (
                            tar_left.axisValue +
                            "<br/>" +
                            tar_left.data +
                            " tce/万元" +
                            "<br/>" +
                            tar_right.data +
                            " 万元"
                        );
                    }
                },
                // legend: {
                //     data: ["综合能耗"],
                //     textStyle: { fontSize: 12, color: "#fff" }
                // },
                grid: {
                    left: "3%",
                    right: "2%",
                    bottom: "3%",
                    containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        axisLabel: {
                            color: utils.getFontColor(),
                            fontSize: 14
                        },

                        axisLine: {
                            lineStyle: { color: utils.getFontColor() }
                        },
                        xAxisLeft: utils.getFontColor(),
                        data: this.x_list
                    }
                ],
                yAxis: [
                    {
                        name: "tce/万元",
                        type: "value",
                        yAxisTop: "yellow",
                        position: "left",
                        nameTextStyle: {
                            color: utils.getFontColor(),
                            padding: 10
                        },
                        axisLabel: {
                            color: utils.getFontColor(),
                            fontSize: 14
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                // type:'dashed',
                                color: utils.getFontColor()
                            }
                        },
                        axisLine: {
                            lineStyle: { color: utils.getFontColor() }
                        },
                        xAxisLeft: utils.getFontColor()
                    },
                    {
                        name: "万元",
                        type: "value",
                        yAxisTop: "yellow",
                        position: "right",
                        nameTextStyle: {
                            color: utils.getFontColor(),
                            padding: 10
                        },
                        axisLabel: {
                            color: utils.getFontColor(),
                            fontSize: 14
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                // type:'dashed',
                                color: [utils.getFontColor()]
                            }
                        },
                        axisLine: {
                            lineStyle: { color: utils.getFontColor() }
                        },
                        xAxisLeft: utils.getFontColor()
                    }
                ],
                series: [
                    {
                        // yAxisIndex: 1,
                        name: "",
                        type: "line",
                        itemStyle: {
                            normal: {
                                color: "#ff6e6e"
                            }
                        },
                        smooth: true,
                        symbol: "none",
                        data: this.y_list
                    },
                    {
                        yAxisIndex: 1,
                        name: "",
                        type: "bar",
                        barWidth: "40%",
                        itemStyle: {
                            normal: {
                                color: "#00dbf7"
                            }
                        },
                        data: this.y_list_right
                    }
                ]
            };
            return option;
        }
    }
};
</script>
<style lang="scss">
.energy-check-container {
    padding: 10px 20px 10px 20px;
    // background: transparent;
    width: 100%;
    height: 100%;
    overflow: auto;
    .search_wraps-check {
        margin-top: 20px;
        margin-bottom: 30px;
        width: 100%;
    }
    .check-title {
        font-size: 14px;
        text-indent: 1em;
        line-height: 36px;
        color: #fff;
    }
    .check-wrap {
        width: 98%;
        height: 450px;
        color: #fff;
        background-size: 100% 100%;
        .check-echarts-wrap {
            width: 96%;
            height: 85%;
            // margin: 20px auto 20 auto;
            clear: both;
            .echarts {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
